<template>
     <div id="AppAlarm" class="app-inner">
           <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="addAppAlarm">
        新增报警规则
      </div>
    </div>
    <div class="p-tit-c">
        <div class="businessList-filter">
          <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">报警名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入应用名称" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">报警ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入应用ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
      </div>
                <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">报警分类：</div>
           <el-select
            v-model="value"
            clearable
            placeholder="全部"
            class="flex"
             @change="searchList"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.appName + '-' + item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
                <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">报警级别：</div>
           <el-select
            v-model="value1"
            clearable
            placeholder="全部"
            class="flex"
             @change="searchList"
          >
            <el-option
              v-for="item in options1"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen">
        <div class="label">启用状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(0)"
        >
          不限
        </div>
        <el-radio v-model="radio0" label="1"  @change="searchList">启用中</el-radio>
         <el-radio v-model="radio0" label="0"  @change="searchList">禁用</el-radio>
      </div>
      <div class="businessList-filter-list flex align-cen">
        <div class="label">连锁状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(1)"
        >
          不限
        </div>
        <el-radio v-model="radio1" label="1"  @change="searchList">开启</el-radio>
         <el-radio v-model="radio1" label="0"  @change="searchList">关闭</el-radio>
      </div>
       <div class="businessList-filter-list flex align-cen">
        <div class="label">自动闭锁状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(2)"
        >
          不限
        </div>
        <el-radio v-model="radio2" label="1"  @change="searchList">开启</el-radio>
         <el-radio v-model="radio2" label="0"  @change="searchList">关闭</el-radio>
      </div>
       <div class="businessList-filter-list flex align-cen">
        <div class="label">复位方式：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(3)"
        >
          不限
        </div>
        <el-radio v-model="radio3" label="1"  @change="searchList">手动复位</el-radio>
         <el-radio v-model="radio3" label="2"  @change="searchList">自动复位</el-radio>
      </div>
       <div class="businessList-filter-list flex align-cen">
                     <div class="label">创建时间：</div>
                      <el-date-picker
                            v-model="value2"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="searchList"
                            >
                            </el-date-picker>
     </div>
        <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="searchList">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
        </div>
        </div>
        <div class="businessList-container">
         <div class="businessList-container-table">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"

        >
            <el-table-column label="报警ID" align="center" prop="id" width="200">
             </el-table-column>
             <el-table-column label="报警名称" align="center" prop="name">
             </el-table-column>
                <el-table-column label="报警级别" align="center">
                  <template  slot-scope="scope">
                    <span>{{getLeavlType(scope.row.alarmLevel)}}</span>
                  </template>
               </el-table-column>
               <el-table-column label="报警分类" align="center" prop="classifyName">
             </el-table-column>
                <el-table-column label="报警条件" align="center">
                  <template  slot-scope="scope">
                    <span style="color:red;cursor: pointer;" @click="openAlarmRule(scope.row)">查看报警条件</span>
                  </template>
               </el-table-column>
                 <el-table-column label="自动闭锁状态" align="center">
                  <template  slot-scope="scope">
                    <span>{{scope.row.autoLock == 1 ? '开启' : '关闭'}}</span>
                  </template>
               </el-table-column>
                <el-table-column label="自动闭锁规则" align="center">
                   <template  slot-scope="scope">
                    <span v-if="scope.row.autoLock == 1">触发预警后锁定{{scope.row.lockTime}}分钟</span>
                    <span v-else>-</span>
                  </template>
               </el-table-column>
                  <el-table-column label="连锁状态" align="center">
                  <template  slot-scope="scope">
                    <span>{{scope.row.interlock == 1 ? '开启' : '关闭'}}</span>
                  </template>
               </el-table-column>
                 <el-table-column label="连锁规则" align="center" prop="interlockRule">
                    <template  slot-scope="scope">
                    <span>{{scope.row.interlockRule  || '-'}}</span>
                  </template>
                  
             </el-table-column>
              <el-table-column label="复位方式" align="center">
                  <template  slot-scope="scope">
                    <span>{{scope.row.resetMode == 1 ? '手动复位' : scope.row.resetMode == 2 ? '自动复位' : '自动复位-手动复位'}}</span>
                  </template>
               </el-table-column>
                    <el-table-column label="自动复位条件" align="center">
                  <template  slot-scope="scope">
                    <span style="color:red;cursor: pointer;" @click="openAlarmRule1(scope.row)">查看自动复位条件</span>
                  </template>
               </el-table-column>
                  <el-table-column label="启用状态" align="center" width="150">
                <template slot-scope="scope">
                  <div class="buStatus"  @click="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
                 <el-table-column label="创建时间" align="center" prop="createTime">
             </el-table-column>
                    <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
             <template slot-scope="scope">
                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="addAppAlarm(scope.row)">编辑</el-button>
                     <el-button type="text" size="small"  slot="reference" style="color:red" @click="deleteC(scope.row)">删除</el-button>
             </template>
          </el-table-column>
        </el-table>
         <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
         </div>
        </div>
             <el-dialog
  title="报警条件"
  :visible.sync="centerDialogVisible2"
  width="60%"
  :append-to-body="true"
  center>
        <div class="businessList-container-table">
              <el-table
          ref="multipleTable1"
          :data="ruleArr"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"

        >
            <el-table-column  label="点位名称" align="center">
               <template slot-scope="scope">
             {{scope.row.tag}}--{{scope.row.name}}
            </template>
          </el-table-column>

          <el-table-column prop="upper" label="上限阈值" align="center">
          </el-table-column>
           <el-table-column prop="duration" label="持续时间（s）" align="center">
          </el-table-column>
           <el-table-column prop="lower" label="下限阀值" align="center">
          </el-table-column>
           <el-table-column prop="logic" label="复合逻辑" align="center">
          </el-table-column>
           </el-table>
      </div>
 </el-dialog>
           <el-dialog
  title="复位条件"
  :visible.sync="centerDialogVisible3"
  width="30%"
  :append-to-body="true"
  center>
        <div class="businessList-container-table">
              <el-table
          ref="multipleTable1"
          :data="ruleArr1"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"

        >
            <el-table-column  label="点位名称" align="center">
               <template slot-scope="scope">
             {{scope.row.tag}}--{{scope.row.name}}
            </template>
          </el-table-column>

          <el-table-column prop="triggerValue" label="触发阈值" align="center">
          </el-table-column>
           </el-table>
      </div>
 </el-dialog>
     </div>
</template>
<script>
import {getAlarmClassify1,alarmRuleList,editAlarmRule,triggerAlarmRule,triggerAlarmRule1,getAlarmRule} from "@/api/enterprise/index"  //报警分类、报警分页、修改报警规则、触发报警规则条件列表、复位条件列表、删除报警
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    components:{
      paginaTion,
    },
    data () {
        return {
        businessInfo:{},
          ruleArr:[],
          ruleArr1:[],
          centerDialogVisible2:false,
          centerDialogVisible3:false,
           startTime:'',
           endTime:'',
           totalCount:0,
           currentPage: 1, //初始页
           PageSize: 10, //每页的数据
           list:[],
           search:'',
           search1:'',
           value:'',
           value1:'',
           value2:[],
           radio0:'',
           radio1:'',
           radio2:'',
           radio3:'',
           options:[],
           options1:[
            {
                id:4,
                name:'紧急'
            },
            {
                id:3,
                name:'严重'
            },
            {
                id:2,
                name:'一般'
            },
            {
                id:1,
                name:'提示'
            },
           ],
            pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },

        }
    },
    created() {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getClass()
        this.getAlarmRuleList()
    },
    methods: {
       // 删除报警
        deleteC(data){
             this.$confirm('确认后，将删除该预警信息，仍要删除吗？', '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  getAlarmRule({id:data.id},'DELETE')
                  .then(res =>{
                    if(res.code == 0){
                      this.$util.Notifi('删除成功','success','fa-check')
                   this.getAlarmRuleList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
                  .catch(err =>{console.log(err)})
              }).catch(() => {          
              });
        },
      // 打开报警条件窗口
      openAlarmRule(data){
        this.ruleArr = []
        triggerAlarmRule({ruleId:data.id})
        .then(res =>{
          this.ruleArr = res.data
        })
        this.centerDialogVisible2 = true
      },
       // 打开复位条件窗口
      openAlarmRule1(data){
        this.ruleArr1 = []
        triggerAlarmRule1({ruleId:data.id})
        .then(res =>{
          this.ruleArr1 = res.data
        })
        this.centerDialogVisible3 = true
      },
        // 状态开启
              changeStatus(e){
            if(e.row.state == 1){
           this.$confirm('确认关闭吗？', '报警规则禁用', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editPaper(e)
                        }).catch(() => {          
                        });
        }else{
            this.editPaper(e)
        }
        },
                 editPaper(e){
             editAlarmRule({
                businessId:this.businessInfo.id,
                id:e.row.id,
                state:e.row.state == 1 ? '0' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('状态修改成功'); 
                    this.getAlarmRuleList()
                  }
                })
                .catch(err => {
                })
        },
         emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getAlarmRuleList()
      },
        // 获取报警分类列表
        getAlarmRuleList(){
            let params = {
                businessId:this.businessInfo.id,
                id:this.search1,
                name:this.search,
                classifyId:this.value,
                alarmLevel:this.value1,
                autoLock:this.radio2,
                interlock:this.radio1,
                resetMode:this.radio3,
                state:this.radio0,
               createTimeStart:this.startTime || '',
                createTimeEnd:this.endTime || '',
                current:this.currentPage,
                size:this.PageSize
            }
            
            alarmRuleList(params)
            .then(res =>{
                if(res.data.records){
                this.list = res.data.records
                this.totalCount = res.data.total
              }
            })
        },
        // 初始化
        reset(){
            this.search =''
            this.search1 =''
            this.value = ''
            this.value1 = ''
            this.value2 = []
            this.radio0 = ''
            this.radio1 = ''
            this.radio2 = ''
            this.radio3 = ''
            this.startTime = ''
            this.endTime = ''
            this.currentPage = ''
            this.getAlarmRuleList()
        },
        searchList(){
             if(this.value2){
             this.startTime = this.value2[0]
            this.endTime =  this.value2[1]
            }else{
            this.startTime = ''
            this.endTime =  ''
            }
           this.currentPage = 1
           this.getAlarmRuleList()
        },
        allradio(type){
            this[`radio${type}`] = ''
            this.currentPage = 1
            this.getAlarmRuleList()
        },
        // 获取报警分类列表
        getClass(){
            getAlarmClassify1({appId:'',name:'',businessId:this.businessInfo.id})
            .then(res =>{
                this.options = res.data
            })
        },
        // 新增报警规则
        addAppAlarm(data){
            if(data.isPlat == 1) return  this.$util.Notifi('平台端报警规则不允许修改','error','fa-exclamation-circle')
           this.$router.push({
        name: "teaddAlarm",
        query:{
            id:data.id,
        }
        })
        },
           getLeavlType(type){
            const actionTypelanes = {
                0:'',
                1:'提示',
                2:'一般',
                3:'严重',
                4:'紧急',
            }
            return actionTypelanes[type]
        },
    },
}
</script>
<style lang="scss" scoped>
.buStatus{
        width: 50px;
        margin: 0 auto;
      }
       ::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
  }
</style>